/* eslint-disable */
import React, {  useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../../generic-components/Heading';
import { LinkShareTypes } from './LinkShare';
import FBIcon from '../../../../assets/icons/svg/colored-icons/ic-colored-messanger.svg';
import WhatsAppIcon from '../../../../assets/icons/svg/colored-icons/ic-colored-whatsapp.svg';
import EnvelopIcon from '../../../../assets/svg/envelope-stroke.svg';
import MessageIcon from '../../../../assets/icons/svg/colored-icons/ic-colored-messages.svg';
import { LiliToolTip } from '../../../../generic-components/LiliToolTip';
import { PROFILE_STYLES } from '../../../../flows/profile/constants';
import Button from '../../../../generic-components/Button';;
import { useStore } from '../../../../store';
import { SocialShareItem } from 'src/components/SocialSharePopUp/SocialShareItem';

interface IProps {
  onCloseShare?: () => void;
}

export const LinkShareWrapper = ({ onCloseShare }: IProps) => {
  const invoiceData = useStore((state) => state.invoiceData);
  const { t } = useTranslation();
  const [isCopyActive, setIsCopyActive] = useState<boolean>(false);


  const getShareableLinks = () => {
    if (window.navigator.userAgent.includes('Macintosh')) {
      return [
        { iconAsset: EnvelopIcon, type: LinkShareTypes.Email, title: 'Email' },
        { iconAsset: FBIcon, type: LinkShareTypes.Facebook, title: 'Messenger' },
        { iconAsset: WhatsAppIcon, type: LinkShareTypes.WhatsApp, title: 'WhatsApp' },
        { iconAsset: MessageIcon, type: LinkShareTypes.IMessage, title: 'Messages' },
      ];
    }
    return [
      { iconAsset: EnvelopIcon, type: LinkShareTypes.Email, title: 'Email' },
      { iconAsset: FBIcon, type: LinkShareTypes.Facebook, title: 'Messenger' },
      { iconAsset: WhatsAppIcon, type: LinkShareTypes.WhatsApp, title: 'WhatsApp' },
    ];
  };

  useEffect(() => {
    if (isCopyActive) {
      window.navigator.clipboard.writeText(invoiceData?.paymentUrl || '');
      setTimeout(() => {
        setIsCopyActive(false);
      }, 1500);
    }
  }, [isCopyActive]);

  return (
    <div
      onClick={() => {
        if (onCloseShare) onCloseShare();
      }}
      className='absolute inset-0 bg-bw08Opacity backdrop-blur-sm flex items-center justify-center fadeIn'
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className='bg-bw00 text-center flex flex-col items-center rounded-[8px] py-[30px] px-[30px] max-w-[500px]'
      >
        <Heading title={t('SHARE_INVOICE')} className='font-metricRMedium text-bw08 heading-[32px] text-[24px]' />
        <Heading
          title={t('SHARE_INVOICE_SUB_TITLE')}
          className='font-metricR text-bw07 heading-[24px] text-[16px] mb-[18px]'
        />

        <SocialShareItem
          recipientName={invoiceData?.invoiceRecipient?.name}
          invoiceNumber={invoiceData?.invoiceNumber}
          paymentUrl={invoiceData?.paymentUrl}
          shareItems={getShareableLinks()}
        />
        <div className='flex items-center justify-between w-full rounded-[8px] border border-bw03 px-[10px] py-[5px] mt-[24px]'>
          <LiliToolTip
            tooltipClassName='max-w-[70%] relative'
            toolTipChildren={
              <Heading
                title={invoiceData?.paymentUrl || ''}
                className='font-metricR text-bw08 text-[14px] w-[420px] break-words leading-[20px]'
              />
            }
            conditionalAppearance
          >
            <Heading
              title={invoiceData?.paymentUrl || ''}
              className='font-metricR text-bw08 text-[14px] w-full truncate leading-[20px]'
            />
          </LiliToolTip>

          <LiliToolTip
            childrenClassName={PROFILE_STYLES.COPY_TOOLTIP}
            tooltipClassName='w-fit relative'
            toolTipChildren={
              isCopyActive ? (
                ''
              ) : (
                <Heading title={t('ACCOUNT_DETAILS_COPY_SHORT')} className='text-bw00 font-metric text-[14px]' />
              )
            }
          >
            <Button
              childElement={
                <Heading
                  title={isCopyActive ? t('COPY_LINK_ACTIVE') : t('COPY_LINK')}
                  className='font-metricRMedium text-[14px] text-action03'
                />
              }
              className='py-[8px] px-[16px] rounded-[4px] hover:bg-bw02'
              id=''
              onClick={() => setIsCopyActive(true)}
            />
          </LiliToolTip>
        </div>
      </div>
    </div>
  );
};
